import { FC } from 'react';

const iconLamp = require('./icon_lamp.svg');

export const IconLamp: FC = () => {
  return <img alt="icon_lamp" height={79} src={iconLamp} width={74} />;
};

IconLamp.displayName = 'IconLamp';
